// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from '../../api';

/**
 * @param {import('club-sauce/public/network/loadbalancer/index.raw').LWApiPublicNetworkLoadBalancerStrategiesParamsI} params
 * @param {import('@tanstack/react-query').UseQueryOptions} options
 */
const useLoadBalancerStrategies = (
	params,
	{ keepPreviousData, enabled } = {},
) =>
	useQuery({
		queryKey: ['/network/loadbalancer/strategies', params],
		queryFn: () => api.network.loadbalancer.apiRaw.strategies(params),
		keepPreviousData,
		enabled,
	});

export default useLoadBalancerStrategies;
